class SocialsSlider extends HTMLElement {
  constructor() {
    super();
    
    this.marquees = this.querySelectorAll('[data-css-marquee]');
    this.speed = this.getAttribute('data-speed');

    if (this.marquees.length > 0) {
      this.initSocialsSlider();
    }
  }
  
  initSocialsSlider() {
    // Duplicate each [data-css-marquee-list] element inside its container
    this.marquees.forEach(marquee => {
      marquee.querySelectorAll('[data-css-marquee-list]').forEach(list => {
        const duplicate = list.cloneNode(true);
        marquee.appendChild(duplicate);
      });
    });

    // Create an IntersectionObserver to check if the marquee container is in view
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        entry.target.querySelectorAll('[data-css-marquee-list]').forEach(list => 
          list.style.animationPlayState = entry.isIntersecting ? 'running' : 'paused'
        );
      });
    }, { threshold: 0 });
    
    // Calculate the width and set the animation duration accordingly
    this.marquees.forEach(marquee => {
      marquee.querySelectorAll('[data-css-marquee-list]').forEach(list => {
        list.style.animationDuration = (list.offsetWidth / this.speed) + 's';
        list.style.animationPlayState = 'paused';
      });
      observer.observe(marquee);
    });

    // Make marquee stop on hover
    this.marquees.forEach(marquee => {
      marquee.addEventListener('mouseenter', () => {
        marquee.querySelectorAll('[data-css-marquee-list]').forEach(list => {
          list.style.animationPlayState = 'paused';
        });
      });
      marquee.addEventListener('mouseleave', () => {
        marquee.querySelectorAll('[data-css-marquee-list]').forEach(list => {
          list.style.animationPlayState = 'running';
        });
      });
    });
  }
}

customElements.define('socials-slider', SocialsSlider); 